import { connect } from 'react-redux';

import USERLIST from '../../components/sider/userlist';

export default connect()(USERLIST);



// WEBPACK FOOTER //
// ./containers/sider/userlist.js